import { WebSpecialOfferService } from './web-special-offer.service';

export * from './web-special-offer.reducer';

export const webSpecialOfferService = new WebSpecialOfferService();
export * as selectors from './web-special-offer.selectors';
